// A domain's lifecycle. Two states, and the difference between them is whether
// the public renderer will answer on this hostname.
//
// `pending` is a CLAIM, not a mapping. Anyone can ask to attach any hostname —
// that is what makes the table's global uniqueness useful — so a row exists
// from the moment it is asked for, and until the TXT record proves control it
// resolves to nothing. The renderer reads `isActive` and only `isActive`.
export const PENDING = "pending";
export const ACTIVE = "active";

// Asymmetric on purpose, and the opposite way round from a site's.
//
// @common/schema/site/status leans towards leaving a row alone: an unknown
// status is still VISIBLE, because hiding somebody's content on a value this
// service has never heard of is worse than showing it. Here the same reasoning
// points the other way. A row this file cannot recognise is one whose ownership
// was never established as far as anything here can tell, and serving a tenant's
// pages on a hostname on that basis is the failure worth avoiding. So an
// unknown status is NOT active.
export const isActive = (row) => Boolean(row) && row.status === ACTIVE;
